export default __webpack_public_path__ + "static/media/CustonBottle.a9997b58.png";